



























































































    import { Component, Vue } from 'vue-property-decorator'
	import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

    @Component
    export default class Breadcrumb extends Vue {

        data() {
            return {
                PageTitle: "Breadcrumb"
            }
        }
        mounted() {
            new Reveal.revealOnScrollModule()
        }
    }
